import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Normal app render
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Offline caching is intentionally disabled for the storefront. The previous
// cache-first worker could preserve an HTML SPA fallback under a hashed JS URL
// after a deploy and leave that browser on a permanent black screen.
serviceWorkerRegistration.unregister();
